import { z } from 'zod'
import { oc } from '@orpc/contract'
import { patientInvoiceKindSchema } from './copay-status.contract'

// Updating a charge's receipt_email makes Stripe re-send the receipt — this is
// the "Resend to patient" action for paid/refunded co-pays.
export const resendCopayReceipt = oc
  .route({ method: 'POST', path: '/v2/copay/{encounterId}/resend-receipt' })
  .input(
    z.object({ encounterId: z.string().min(1), kind: patientInvoiceKindSchema.default('copay') }),
  )
  .output(z.object({ sentTo: z.string() }))
